import { get, post } from '../utils/request';

// 加入购物车
export const saveToCart = (params:any) => {
  return post<any>('/cart/save_to_cart',params);
};

// 获取购物车列表
export const getMyCartList = (query:any) => {
  return get<any>('/cart/get_my_cart_list',query);
};  


// 删除购物车商品
export const deleteCartProduct = (params:any) => {
  return post<any>('/cart/save_manage_cart',params);
};

// cart/save_manage_cart
// {
//   "product_list":[
//       {
//           "product_id":"PROD-71ba237aef511753068329140",
//           "product_sku_id":"sku9079849108409807",
//           "quantity":2,
//       }
//   ]
// }


